import { Component, OnDestroy, OnInit } from '@angular/core';
import { Reward } from '@core/models/reward';
import { QuizModuleService } from '../../quiz-module.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-gifts-list',
  templateUrl: './gifts-list.component.html',
  styleUrls: ['./gifts-list.component.scss']
})
export class GiftsListComponent implements OnInit, OnDestroy {
  rewards: Reward[];
  private unsubscribe$ = new Subject();

  constructor(private quizService: QuizModuleService) { }

  getUserGifts(): void {
    this.quizService
      .getUserGifts()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (res) => {
          this.rewards = res;
        },
        (err) => {
          console.log(err);
        }
      );
  }

  ngOnInit(): void {
    this.getUserGifts();
  }

  ngOnDestroy(): void {
      this.unsubscribe$.next(true);
  }

}
